export default "__VITE_ASSET__CrvfCfe6__"